/**
 * TTStats Brand Theme Constants
 *
 * Central location for brand colors and theme values used throughout the application.
 */

// Brand Colors
export const BRAND_BLUE = '#1C7AD6';

// You can add more theme constants here as needed
// export const BRAND_BLUE_LIGHT = '#...'
// export const BRAND_BLUE_DARK = '#...'
